<template>
  <div class="md-layout">
    <md-card>
      <md-card-header
        v-if="!everythingLoaded"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon class="load-rotate">hourglass_empty</md-icon>
        </div>
        <h4 class="title">Laden</h4>
      </md-card-header>
      <md-card-header
        v-if="everythingLoaded"
        class="md-card-header-icon md-card-header-green"
      >
        <div class="card-icon">
          <md-icon>date_range</md-icon>
        </div>
        <h4 class="title">Beschikbaarheid</h4>
      </md-card-header>
      <md-card-content v-if="everythingLoaded">
        <md-checkbox v-model="includeHolidays">Feestdagen</md-checkbox>
        <br />
        <md-checkbox v-model="includeUnavailablePeriods"
          >Afwezige perioden</md-checkbox
        >
        <br />
        <md-checkbox v-model="includeDriverUnavailable"
          >Chauffeur niet beschikbaar</md-checkbox
        >
        <fullCalendar
          locale="nl"
          :button-text="{ today: 'Huidige week' }"
          ref="calendar"
          defaultView="listWeek"
          :valid-range="calendarValidRange"
          :plugins="calendarPlugins"
          :events="getEvents"
          :first-day="1"
          :header="header"
          :buttonIcons="buttonIcons"
          height="auto"
          allDayText="Gehele dag"
        />
      </md-card-content>
      <md-card-actions>
        <md-button
          native-type="button"
          @click.native.prevent="handleGoToOverview"
          class="md-success"
          >Perioden beheren</md-button
        >
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import DriversMethods from "./DriversMethods";

var today = new Date();
var y = today.getFullYear();
var m = today.getMonth();
var d = today.getDate();

import ShiftsMethods from "../Shifts/ShiftsMethods.js";
import RoutesMethods from "../Routes/RoutesMethods";
import listPlugin from "@fullcalendar/list";
import FullCalendar from "@fullcalendar/vue";
import nlLocale from "@fullcalendar/core/locales/nl";

export default {
  components: {
    FullCalendar
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    calendarValidRange: function() {
      return {
        start: this.calanderGetStartDate,
        end: this.calanderGetStopDate
      };
    },
    calanderGetStartDate: function() {
      var startDate = new Date(today);
      startDate.setUTCDate(startDate.getUTCDate() - 40);
      return RoutesMethods.formatDate(
        startDate.getUTCFullYear() +
          "-" +
          (startDate.getUTCMonth() + 1) +
          "-" +
          startDate.getUTCDate()
      );
    },
    calanderGetStopDate: function() {
      var stopDate = new Date(today);
      stopDate.setUTCDate(stopDate.getUTCDate() + 180);
      return RoutesMethods.formatDate(
        stopDate.getUTCFullYear() +
          "-" +
          (stopDate.getUTCMonth() + 1) +
          "-" +
          stopDate.getUTCDate()
      );
    },
    calendarGetDateRangeArray: function() {
      var dates = [];
      var startDate = this.calanderGetStartDate;
      var stopDate = this.calanderGetStopDate;

      var date = new Date(startDate);
      dates.push(startDate);

      while (
        stopDate >
        RoutesMethods.formatDate(
          date.getUTCFullYear() +
            "-" +
            (date.getUTCMonth() + 1) +
            "-" +
            date.getUTCDate()
        )
      ) {
        date.setUTCDate(date.getUTCDate() + 1);
        dates.push(
          RoutesMethods.formatDate(
            date.getUTCFullYear() +
              "-" +
              (date.getUTCMonth() + 1) +
              "-" +
              date.getUTCDate()
          )
        );
      }

      return dates;
    },
    getEvents: function() {
      var events = [];
      var dates = this.calendarGetDateRangeArray;

      for (var i in dates) {
        if (this.includeHolidays && this.isDateHoliday(dates[i])) {
          events.push({
            title: this.getHolidayNameByDate(dates[i]),
            start: new Date(dates[i]),
            className: "event-purple",
            backgroundColor: "purple",
            allDay: true
          });

          continue;
        }

        if (
          this.includeUnavailablePeriods &&
          this.isDateUnavailablePeriod(dates[i])
        ) {
          events.push({
            title: this.isDateUnavailablePeriodLabelByDate(dates[i]),
            start: new Date(dates[i]),
            className: "event-lime",
            backgroundColor: "#827717",
            allDay: true
          });

          continue;
        }

        for (var group in this.groups) {
          for (var routeIndex in this.routes) {
            var dayRouteStatus =
              this.dataRoutePeriods.length === 0
                ? 0
                : RoutesMethods.getperiodDayStatusByDate(
                    dates[i],
                    RoutesMethods.getperiodByDate(
                      dates[i],
                      this.dataRoutePeriods[routeIndex]
                    )
                  );
            if (dayRouteStatus !== 1) {
              continue;
            }

            var shifts = this.getShiftsByRouteId(this.routes[routeIndex].id);

            for (var shiftIndex in shifts) {
              var dayShiftStatus = ShiftsMethods.getperiodDayStatusByDate(
                dates[i],
                ShiftsMethods.getperiodByDate(
                  dates[i],
                  this.dataShiftPeriods(shifts[shiftIndex].shift_index),
                  this.routes[routeIndex]["id"]
                )
              );
              if (dayShiftStatus !== 1) {
                continue;
              }

              var driverAvailability = DriversMethods.getDriverAvailabilityByDateRouteShift(
                this.availablePeriods,
                dates[i],
                this.routes[routeIndex].id,
                shifts[shiftIndex].id
              );

              if (
                driverAvailability === 9 &&
                this.includeDriverUnavailable === false
              ) {
                continue;
              }

              var startStopTimes = ShiftsMethods.getperiodDayStartStopTimesByDate(
                dates[i],
                ShiftsMethods.getperiodByDate(
                  dates[i],
                  this.dataShiftPeriods(shifts[shiftIndex].shift_index),
                  this.routes[routeIndex]["id"]
                )
              );

              let routeNumber = parseInt(routeIndex) + 1;
              events.push({
                title:
                  "(" +
                  routeNumber +
                  ") " +
                  this.routes[routeIndex].name +
                  " " +
                  shifts[shiftIndex].name +
                  " - " +
                  this.getSelectableAvailabilityTypeLabel(driverAvailability),
                start: new Date(dates[i] + " " + startStopTimes[0]),
                end: new Date(dates[i] + " " + startStopTimes[1]),
                backgroundColor: this.getSelectableAvailabilityTypeColor(
                  driverAvailability
                ),
                allDay: false
              });
            }
          }
        }
      }

      return events;
    },
    dataRoutePeriods: function() {
      let periods = [];

      for (let index in this.routesPeriods) {
        periods[index] = [];
        if (this.routesPeriods[index] === undefined) {
          continue;
        }

        for (var i in this.routesPeriods[index]) {
          if (this.routesPeriods[index][i].id.length !== 36) {
            continue;
          }

          periods[index].push(this.routesPeriods[index][i]);
        }
      }

      return periods;
    }
  },
  data() {
    return {
      daysOfTheWeek: {
        1: "Maandag",
        2: "Dinsdag",
        3: "Woensdag",
        4: "Donderdag",
        5: "Vrijdag",
        6: "Zaterdag",
        7: "Zondag"
      },
      loaded: {
        groups: false,
        routes: false,
        shifts: false,
        shiftsRoutes: false,
        routesPeriods: false,
        shiftsPeriods: false,
        holidays: false,
        unavailablePeriods: false,
        selectableAvailabilityTypes: false
      },
      groups: [],
      routes: [],
      shifts: [],
      holidays: [],
      routesPeriods: [],
      shiftsPeriods: [],
      includeHolidays: true,
      includeUnavailablePeriods: true,
      includeDriverUnavailable: false,
      availablePeriods: [],
      unavailablePeriods: [],
      selectableAvailabilityTypes: [],
      calendarPlugins: [listPlugin],
      header: {
        left: "",
        center: "title",
        right: "today,prev,next"
      },
      buttonIcons: {
        close: "fa-times",
        prev: "left-single-arrow",
        next: "right-single-arrow",
        prevYear: "fa-angle-double-left",
        nextYear: "fa-angle-double-right"
      }
    };
  },
  methods: {
    loadRouteGroups() {
      this.$http.get(this.$apiBaseUrl + "routes/groups").then(
        response => {
          this.groups = response.data.routeGroups;
          this.loaded.groups = true;
        },
        response => {}
      );
    },
    loadRoutes() {
      this.$http.get(this.$apiBaseUrl + "routes").then(
        response => {
          let routes = response.data.routes;

          for (var i = 0; i < routes.length; i++) {
            routes[i].order = routes[i].order.toString();
            routes[i].isreserve = routes[i].isreserve.toString();
            routes[i].shiftIds = [];

            if (this.selectedRouteId === null) {
              this.selectedRouteId = routes[i].id;
            }
          }

          this.routes = routes;
          this.loaded.routes = true;
          this.loadRoutesPeriods();
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van routes",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadRoutesPeriods() {
      this.loaded.routesPeriods = false;
      let routesPeriods = [];
      let routeIds = "";

      for (let i in this.routes) {
        if (routeIds !== "") {
          routeIds = routeIds + ",";
        }

        routeIds = routeIds + this.routes[i].id;
      }

      this.$http.get(this.$apiBaseUrl + "routes/periods/" + routeIds).then(
        response => {
          for (let i in response.data.routesPeriods) {
            routesPeriods.push(
              RoutesMethods.reformatLoadedRoutePeriods(
                response.data.routesPeriods[i]
              )
            );
          }
          this.routesPeriods = routesPeriods;
          this.loaded.routesPeriods = true;
        },
        response => {
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    loadShifts() {
      this.$http.get(this.$apiBaseUrl + "shifts").then(
        response => {
          let shifts = response.data.shifts;

          for (let i in shifts) {
            shifts[i]["routeIds"] = [];
          }

          this.shifts = shifts;
          this.loaded.shifts = true;
          this.loadShiftsRoutes();
          this.loadShiftPeriods();
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van diensten",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadShiftsRoutes() {
      this.loaded.shiftsRoutes = false;
      this.$http.get(this.$apiBaseUrl + "shifts/routes").then(
        response => {
          let routeIds = {};
          for (let s in this.shifts) {
            routeIds[this.shifts[s].id] = [];
          }

          for (let shiftId in response.data.shifts_routes) {
            for (let i in response.data.shifts_routes[shiftId]) {
              routeIds[shiftId].push(
                response.data.shifts_routes[shiftId][i].id
              );
            }
          }

          for (let s in this.shifts) {
            this.shifts[s]["routeIds"] = routeIds[this.shifts[s].id];
          }

          this.loaded.shiftsRoutes = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van diensten",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadShiftPeriods() {
      this.loaded.shiftsPeriods = false;
      let shiftsPeriods = [];
      let shiftIds = "";

      for (let i in this.shifts) {
        if (shiftIds !== "") {
          shiftIds = shiftIds + ",";
        }

        shiftIds = shiftIds + this.shifts[i].id;
      }

      this.$http.get(this.$apiBaseUrl + "shifts/periods/" + shiftIds).then(
        response => {
          for (let i in response.data.shiftsPeriods) {
            shiftsPeriods.push(
              ShiftsMethods.reformatLoadedShiftPeriods(
                response.data.shiftsPeriods[i]
              )
            );
          }

          this.shiftsPeriods = shiftsPeriods;
          this.loaded.shiftsPeriods = true;
        },
        response => {
          if (response.status === 403) {
            // this.notifyVue("U heeft geen rechten voor het beheren van routes", 'add_alert', 'danger', 0);
          }
        }
      );
    },
    handleGoToOverview() {
      this.$router.push(
        "/drivers/" + this.$route.params.id + "/availablePeriod"
      );
    },
    loadAvailablePeriods() {
      this.$http
        .get(
          this.$apiBaseUrl +
            "drivers/" +
            this.$route.params.id +
            "/availableperiods"
        )
        .then(
          response => {
            this.availablePeriods = response.data.driverPeriods;
            this.loaded.availablePeriods = true;
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van beschikbaarheidsperioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    loadHolidays() {
      this.loaded.holidays = false;
      this.$http.get(this.$apiBaseUrl + "holidays").then(
        response => {
          this.holidays = response.data.nationalHolidays;
          this.loaded.holidays = true;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van feestdagen",
              "add_alert",
              "danger",
              0
            );
          }
        }
      );
    },
    loadUnavailablePeriods() {
      this.addButtonDisabled = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            "drivers/" +
            this.$route.params.id +
            "/unavailableperiods"
        )
        .then(
          response => {
            this.unavailablePeriods = response.data.unavailablePeriods;
            this.loaded.unavailablePeriods = true;
          },
          response => {
            if (response.status === 403) {
              this.addButtonDisabled = false;
              this.notifyVue(
                "U heeft geen rechten voor het bekijken van Chauffeur afwezigheid",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    isDateUnavailablePeriod(date) {
      for (var i in this.unavailablePeriods) {
        if (
          (this.unavailablePeriods[i].startDate <= date ||
            this.unavailablePeriods[i].startDate === null) &&
          (this.unavailablePeriods[i].stopDate >= date ||
            this.unavailablePeriods[i].stopDate === null)
        ) {
          return true;
        }
      }

      return false;
    },
    isDateUnavailablePeriodLabelByDate(date) {
      for (var i in this.unavailablePeriods) {
        if (
          (this.unavailablePeriods[i].startDate <= date ||
            this.unavailablePeriods[i].startDate === null) &&
          (this.unavailablePeriods[i].stopDate >= date ||
            this.unavailablePeriods[i].stopDate === null)
        ) {
          return this.unavailablePeriods[i].label;
        }
      }

      return "";
    },
    isDateHoliday(date) {
      for (let i in this.holidays) {
        if (this.holidays[i].date === date) {
          return true;
        }
      }

      return false;
    },
    getHolidayNameByDate(date) {
      for (let i in this.holidays) {
        if (this.holidays[i].date === date) {
          return this.holidays[i].name;
        }
      }

      return "";
    },
    getShiftsByRouteId(routeId) {
      let shifts = [];

      for (let i in this.shifts) {
        if (this.shifts[i].routeIds.indexOf(routeId) === -1) {
          continue;
        }

        let shift = this.shifts[i];
        shift["shift_index"] = i;

        shifts.push(shift);
      }

      return shifts;
    },
    dataShiftPeriods(shiftIndex) {
      var periods = [];

      if (this.shiftsPeriods[shiftIndex] === undefined) {
        return periods;
      }

      for (var i in this.shiftsPeriods[shiftIndex]) {
        if (this.shiftsPeriods[shiftIndex][i].id.length !== 36) {
          continue;
        }

        periods.push(this.shiftsPeriods[shiftIndex][i]);
      }

      return periods;
    },
    loadSelectableAvailabilityTypes() {
      this.$http
        .get(this.$apiBaseUrl + "drivers/selectableavailabilitytypes")
        .then(
          response => {
            this.selectableAvailabilityTypes =
              response.data.selectableAvailabilityTypes;
            this.loaded.selectableAvailabilityTypes = true;
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van beschikbaarheidsperioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    getSelectableAvailabilityTypeLabel(availability) {
      return this.selectableAvailabilityTypes[availability].label;
    },
    getSelectableAvailabilityTypeColor(availability) {
      return this.selectableAvailabilityTypes[availability].color;
    }
  },
  mounted() {
    this.loadRouteGroups();
    this.loadRoutes();
    this.loadShifts();
    this.loadHolidays();
    this.loadAvailablePeriods();
    this.loadUnavailablePeriods();
    this.loadSelectableAvailabilityTypes();
  }
};
</script>

<style lang="css"></style>
